export default "__VITE_ASSET__CyM9ItMV__"